import { AfterViewInit, Component, Inject, Input, OnInit, ViewChild, ViewContainerRef, ComponentRef } from '@angular/core';
import { CommonUtility } from '../utility/common.utility';
import { GeneralErrorComponent } from './general-error/general-error.component';
import { errorMessagesNames } from '../../../shared/constants/errors';
import { FOUND_ERROR_TOKEN } from './constants';
import { maintenanceData } from './maintenance.interface';

// TODO: EAP-17799 backfill the tests
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  standalone: false,
})
export class MaintenanceComponent implements OnInit, AfterViewInit {
  private static readonly RESTRICTED_ACCESS: maintenanceData = {
    header: 'Restricted Access',
    message:
      'The page you are trying to access requires additional permissions. Please contact your administrator to grant you access.',
    image: 'restricted-access-graphics.svg',
    imageTxt: 'Page restricted access graphic',
  };
  private static readonly MAINTENANCE: maintenanceData = {
    header: 'We will be back soon!',
    message: 'We are currently undergoing maintenance and apologize for any inconvenience. Thank you for your patience.',
    image: 'maintenancegraphic.svg',
    imageTxt: 'Page maintenance graphic',
  };
  private static errorMessages: Record<string, maintenanceData> = {
    [errorMessagesNames.NoAccessToTenant]: MaintenanceComponent.RESTRICTED_ACCESS,
    [errorMessagesNames.UserInvalid]: MaintenanceComponent.RESTRICTED_ACCESS,
    [errorMessagesNames.ExternalAuthUserNotFound]: MaintenanceComponent.RESTRICTED_ACCESS,
    [errorMessagesNames.TenantNotFound]: MaintenanceComponent.RESTRICTED_ACCESS,
  };

  @Input() public error: any;
  @ViewChild('errorComponent', { read: ViewContainerRef }) container: ViewContainerRef;

  constructor(@Inject(FOUND_ERROR_TOKEN) private caughtError: any) {}

  private createComponent(): void {
    this.container.clear();
    const data: maintenanceData =
      MaintenanceComponent.errorMessages[this.caughtError?.error?.app?.name] ?? MaintenanceComponent.MAINTENANCE;

    const componentRef: ComponentRef<GeneralErrorComponent> = this.container.createComponent(GeneralErrorComponent);
    componentRef.instance.data = data as maintenanceData;
  }

  private static hidePageLoader(): void {
    const pageLoaderElement: HTMLElement = document.querySelector('.page-loader');
    const pageLoaderStyles: HTMLElement = document.getElementById('loaderStyles');
    const loadingScript: HTMLElement = document.getElementById('loadingScript');

    if (pageLoaderElement && CommonUtility.isHostMethod(pageLoaderElement, 'remove')) {
      pageLoaderElement.remove();
    }

    if (pageLoaderStyles && CommonUtility.isHostMethod(pageLoaderStyles, 'remove')) {
      pageLoaderStyles.remove();
    }

    if (loadingScript && CommonUtility.isHostMethod(loadingScript, 'remove')) {
      loadingScript.remove();
    }
  }

  public ngOnInit(): void {
    MaintenanceComponent.hidePageLoader();
  }

  public ngAfterViewInit(): void {
    this.createComponent();
  }
}
